/**
 * Authentication service
 */

import { apiClient } from '../utils/api';
import { setAuthToken, removeAuthToken, getAuthToken } from '../config/api';
import type { User, ApiResponse } from '../../../shared/src/types';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/auth/login', credentials);
  
  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error during login');
  }
  
  if (!response.data.data) {
    throw new Error('Invalid response from server');
  }
  
  const { token, user } = response.data.data;
  setAuthToken(token);
  
  return { token, user };
}

export async function getCurrentUser(): Promise<User> {
  const response = await apiClient.get<ApiResponse<User>>('/auth/me');
  
  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching user');
  }
  
  if (!response.data.data) {
    throw new Error('Invalid response from server');
  }
  
  return response.data.data;
}

export function logout(): void {
  removeAuthToken();
  window.location.href = '/login';
}

export function isAuthenticated(): boolean {
  return !!getAuthToken();
}

